/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-05-24T14:53:19.008
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseReform,
	listRentHouseReformInit,
	listRentHouseReformByAuthorizations,
	deleteRentHouseReform
	
} from '@api/rentmanage/RentHouseReform';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseReform({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseReform(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseReformByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseReformByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseReformInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseReformInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseReform({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseReform({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
